
import { Route } from '@/app/router'

const Departments = () => import('./index.vue')

const DepartmentsMeta = {
	sort: 3,
	displayInSidebar: true,
	displayName: 'department',
	icon: 'fal warehouse-alt',
	activeIcon: 'fas warehouse-alt'
}

const DepartmentsProps = ['page', 'perPage']

export default new Route('/departments', Departments)
	.as('Dashboard:Departments')
	.meta(DepartmentsMeta)
	.props(DepartmentsProps)
	.permissions(['VIEW_DEPARTMENTS'])
